export function disableReactDevTools() {
    if (typeof window === "undefined") return;
    if (process.env.NODE_ENV !== "production") return;

    if (process.env.NODE_ENV === "production") {
        console.debug = () => {};
    }

    const hook = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;

    if (hook) {
        // Override all functions to no-op
        hook.inject = () => {};
        hook.onCommitFiberRoot = () => {};
        hook.onCommitFiberUnmount = () => {};
        hook.renderers = new Map(); // prevent inspection

        // Optional: freeze hook to avoid DevTools patching it later
        Object.freeze(hook);

        // console.log("🚫 React DevTools disabled in production.");
    } else {
        console.log("ℹ️ No DevTools hook found.");
    }

}
